import React, { createContext, useState, useEffect, useCallback } from 'react';
import { auth } from '../config/firebaseApp';

const serializeUser = (firebaseUser) => {
  if (!firebaseUser) return null;
  const { uid, email, emailVerified, displayName } = firebaseUser;
  return { uid, email, emailVerified, displayName };
};

const UserContext = createContext({ user: null, authReady: false, refreshUser: async () => {} });

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authUser) => {
      setUser(serializeUser(authUser));
      setAuthReady(true);
    });

    return () => unsubscribe();
  }, []);

  const refreshUser = useCallback(async () => {
    const currentUser = auth.currentUser;
    if (!currentUser) return;
    await currentUser.reload();
    setUser(serializeUser(auth.currentUser));
  }, []);

  return (
    <UserContext.Provider value={{ user, authReady, refreshUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => React.useContext(UserContext);
